



















import Vue from 'vue';
import Component from 'vue-class-component';

const TicketTypeSelectProps = Vue.extend({
  props: {
    value: {
      type: String,
      default: '',
    },
    types: {
      type: Array,
      required: true,
    },
  },
});

@Component({
  name: 'TicketTypeSelect',
})
export default class TicketTypeSelect extends TicketTypeSelectProps {
  //
}
